var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "point-label",
        {
          staticClass: "mb24",
          attrs: {
            name: _vm.$t("pc_biz_lbl_skill_model").d("能力模型"),
            type: _vm.type,
          },
        },
        [_c("span", [_vm._v(_vm._s(_vm.jqDetails.modelName))])]
      ),
      _vm._l(_vm.jqDetails.jqSkillCatalogs, function (skill) {
        return _c("div", { key: skill.id }, [
          _c("div", { staticClass: "point-text mb5" }, [
            _vm._v("\n      " + _vm._s(skill.name) + "\n    "),
          ]),
          _c(
            "div",
            { staticClass: "flex align-items-center flex-wrap" },
            [
              _vm._l(skill.skillModelClassifications, function (model) {
                return [
                  model.family === 2
                    ? _c("skill-label", {
                        key: model.skillId,
                        staticClass: "mr24 mb12",
                        attrs: {
                          skillModel: model,
                          disabled: _vm.defaultCheckedKeys.includes(
                            model.skillId
                          ),
                        },
                      })
                    : _vm._l(model.skillModelMaps, function (skill) {
                        return _c(
                          "div",
                          [
                            _c("skill-label", {
                              key: skill.skillId,
                              staticClass: "mr24 mb12",
                              attrs: {
                                skillModel: skill,
                                disabled: _vm.defaultCheckedKeys.includes(
                                  skill.skillId
                                ),
                              },
                            }),
                          ],
                          1
                        )
                      }),
                ]
              }),
            ],
            2
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }